import { useContext } from 'react';
import { LanguageCurrencyContext } from '@context/LanguageCurrencyContext';
import { translationsES } from '@translations/es.js';
import { translationsEN } from '@translations/en.js';

export const useTranslation = () => {
  const { lang } = useContext(LanguageCurrencyContext);

  const getTranslation = (key, vars = {}) => {
    const [section, ...rest] = key.split('.');
    const currentLang = lang === 'es' ? translationsES : translationsEN;
    let text = rest.reduce((obj, k) => obj?.[k], currentLang[section]);

    // Reemplazo de variables tipo {{var}}
    if (typeof text === 'string' && vars && Object.keys(vars).length > 0) {
      Object.keys(vars).forEach(k => {
        text = text.replace(new RegExp(`{{${k}}}`, 'g'), vars[k]);
      });
    }
    return text;
  };

  return { translate: getTranslation };
};